<template>
  <div :class="[`rankingItem col-md-4 ${data.progressGoalPercentageCalls >= 100 ? 'concluidaMeta' : (data.progressGoalPercentageCalls < 40 ? 'abaixoMeta' : 'mediaMeta')}`]" style="margin: 15px 0px;">
    <div class="col-md-12" style="background-color: #ecf0f1; padding: 15px;">
      <div class="row">
        <div class="col-md-4 d-none d-md-block d-lg-block">
          <img v-if="data.image"
            :src="`/storage/${data.image}`"
            alt="Imagem de perfil"
            class="rounded-circle"
            style="width: 110%"
          />
           <img v-else
            src="/imgs/default-profile.png"
            alt="Imagem de perfil"
            class="rounded-circle"
            style="width: 110%"
          />
        </div>
        <div class="col-md-8" style="font-size: 12px;">
          <strong>Nome:</strong>
          {{data.name}}
          <br />
          <strong>Ramal:</strong>
          {{data.extension}}
          <br />

          <div v-if="enableCalls == 'true'">
            <center><strong>Meta de Ligações</strong></center>
            <div class="progress">
              <div
                :class="[`progress-bar ${data.progressGoalPercentageCalls >= 100 ? 'bg-success' : (data.progressGoalPercentageCalls < 40 ? 'bg-danger' : 'bg-primary')} progress-bar-striped progress-bar-animated`]"
                role="progressbar"
                :style="`width:${data.progressGoalPercentageCalls}%`"
                :aria-valuenow="data.progressGoalPercentageCalls"
                aria-valuemin="0"
                aria-valuemax="100"
              >{{data.progressGoalPercentageCalls}}%</div>
            </div>
            <div v-if="showCallsInfo == 'true'">
              <strong>Meta Ligações:</strong>
              {{data.goalCalls}}
              <span></span>
              <br />
              <strong>Concluído:</strong>
              {{data.progressGoalCalls}}
              <span></span>
              <br />
            </div>
          </div>

          <div v-if="enableBilling == 'true'">
            <center><strong>Meta de Faturamento</strong></center>
            <div class="progress">
              <div
                :class="[`progress-bar ${data.progressGoalPercentageBilling >= 100 ? 'bg-success' : (data.progressGoalPercentageBilling < 40 ? 'bg-danger' : 'bg-primary')} progress-bar-striped progress-bar-animated`]"
                role="progressbar"
                :style="`width:${data.progressGoalPercentageBilling}%`"
                :aria-valuenow="data.progressGoalPercentageBilling"
                aria-valuemin="0"
                aria-valuemax="100"
              >{{data.progressGoalPercentageBilling}}%</div>
            </div>
            <div v-if="showBillingInfo == 'true'">
              <strong>Meta Faturamento:</strong>
              R$ {{data.goalBilling}}
              <span class="money"></span>
              <br />
              <strong>Concluído:</strong>
              R$ {{data.progressGoalBilling}}
              <span class="money"></span>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  data(){
    return {
      enableBilling: process.env.MIX_RANKING_ENABLE_BILLING,
      showBillingInfo: process.env.MIX_RANKING_SHOW_BILLING_INFO,
      enableCalls: process.env.MIX_RANKING_ENABLE_CALLS,
      showCallsInfo: process.env.MIX_RANKING_SHOW_CALLS_INFO,
    }
  },
  mounted() {
    console.log(this.data);
  }
};
</script>